import { Badge } from "@hulahoop/ui";

export function ShellCounter({ n }: { n: number }) {
  return (
    <Badge variant="chip" className="tabular-nums">
      {n}
    </Badge>
  );
}
